//import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux'
import { triggerGTMPush } from 'redux/actions'

const GTMPush = (props) => {
  const { event, virtualPath, pageNo, pageName, quizAnswer } = props
  props.triggerGTMPush({ event, virtualPath, pageNo, pageName, quizAnswer })
  return null
}

const mapDispatchToProps = dispatch => {
  return {
    triggerGTMPush: (eventData) => dispatch(triggerGTMPush(eventData))
  }
}

export default connect(null, mapDispatchToProps)(GTMPush)

GTMPush.propTypes = {
  event: PropTypes.string,
  virtualPath: PropTypes.string,
  pageNo: PropTypes.string,
  pageName: PropTypes.string,
  quizAnswer: PropTypes.string,
  triggerGTMPush: PropTypes.func.isRequired
}
